import { createContext } from "react";

export type CART_POSITION = "left" | "right";
export type NAVIGATION_POSITION = "top";

export type LocalSettings = {
  allowLayoutEdit: boolean;
  automaticallyCompleteSale: boolean;
  automaticallyPrintReceipts: boolean;
  salesQueueEnabled: boolean;
  integratedTyroReceiptPrinting: boolean;
  integratedTyroSurcharge: boolean;
  printMerchantReceipt: boolean;
  useTyroSimulator: boolean;
  scannerMode: boolean;
  cartPosition: CART_POSITION;
  navigationPosition: NAVIGATION_POSITION;
  stockcountDestinationEmail?: string;
};

export type LocalSettingsContextType = {
  bootstraped: boolean;
  settings: LocalSettings;
  setSetting: (key: keyof LocalSettings, value: any) => void;
};

export const LocalSettingsContext = createContext<
  LocalSettingsContextType | undefined
>(undefined);
